<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="showModal"
    >
        <CForm>
            <CRow>
              <CCol md="12">
                <b>¿Estás seguro de que deseas autorizar los puntos y asignarlos a los participantes del concurso?</b>
                <br />
                <br />
                <i>Este proceso otorgará a los participantes los puntos obtenidos y podrán utilizarlos en cualquier momento.</i>
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="reset" :color="color">Calcular</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"

export default {
  name: 'ChallengeValidationModal',
  props: {

  },
  data () {
    return {
      showModal: false,
      title: "Autorizar Puntos",
      color: "success",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      fields: [
        {key: 'name', label: 'Nombre'},
        {key: 'actions', label: '', class: 'actions' }
      ]
    }
  },
  mounted: async function() {
    
  },
  methods: {
    showValidationsModal (challenge_id) { 
      this.showModal = true;
      this.color = "success";
      this.title = 'Autorizar Puntos';
      this.isEdit = false;
      this.submitted = false;

      this.form = {
          id: 0,
          challenge_id: challenge_id
      }
    },
    reset () {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        this.$emit("validations", this.form );

        this.closeModal();
      }
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          challenge_id: 0
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {

    }
  },
}
</script>